"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cles": {
    "12c121f3": [{
      "hkey": "b4787d98",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "caltron": [{
      "hkey": "b4787d98",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cles"
    }],
    "8fe9a6ac": [{
      "hkey": "b4787d98",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pez": [{
      "hkey": "b4787d98",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cles"
    }]
  }
};
exports["default"] = _default;